var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-empty-state',{attrs:{"title":_vm.$options.i18n.title,"description":_vm.$options.i18n.description,"svg-path":_vm.emptyStateSvgPath,"primary-button-link":_vm.pipelineEditorPath,"primary-button-text":_vm.$options.i18n.buttonText}})}
var staticRenderFns = []

export { render, staticRenderFns }